import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import DetailHeader from '../../components/Detail/detailHeader'
import DetailBody from '../../components/Detail/detailBody'
import '../../css/Detail/detail.css'
import { usePageTitle } from '../../contexts/PageTitleContext'
import { apiGet } from '../../utils/api'

const CABIN_PRICE_FIELDS = [
  { key: 'cruiseinside', label: '인사이드' },
  { key: 'cruiseoutside', label: '오션뷰' },
  { key: 'cruisebalcony', label: '발코니' },
  { key: 'cruisesuite', label: '스위트' },
];

function extractCabinPrices(schedule) {
  if (!schedule) return [];
  return CABIN_PRICE_FIELDS.map(({ key, label }) => {
    const raw = schedule[key];
    if (raw === undefined || raw === null || raw === '') return null;
    const numeric = typeof raw === 'number'
      ? raw
      : Number(String(raw).replace(/[^0-9.]/g, ''));
    if (!Number.isFinite(numeric) || numeric <= 0) return null;
    return { name: label, price: numeric };
  }).filter(Boolean);
}

export default function Detail() {
  const { idx } = useParams()
  const navigate = useNavigate()
  const [detailData, setDetailData] = useState(null)
  const [detailPriceData, setDetailPriceData] = useState(null)
  const [notFound, setNotFound] = useState(false)
  const { setPageTitle } = usePageTitle()

  useEffect(() => {
    setPageTitle('상세페이지')
  }, [setPageTitle])

  // 상세 데이터 먼저 가져오기
  useEffect(() => {
    const fetchDetailData = async () => {
      setDetailPriceData(null);
      try {
        const detailRes = await apiGet('/schedule/get_cruise_schedule_detail.php', {
          schedule_id: idx,
        });

        if (detailRes.result !== 'success') {
          setNotFound(true);
          return;
        }

        setDetailData(detailRes.data);
        setDetailPriceData(extractCabinPrices(detailRes.data?.schedule));
      } catch (error) {
        console.error('상세 데이터 호출 실패:', error);
        setNotFound(true);
      }
    };

    if (idx) fetchDetailData();
  }, [idx]);

  useEffect(() => {
    if (!detailData?.schedule) return;
    const displayFlag = detailData.schedule.line_display_flg;
    if (!displayFlag || displayFlag === 'NON') {
      navigate('/', { replace: true });
    }
  }, [detailData, navigate]);

  if (!detailData) {
    return <div className="loading">로딩 중...</div>
  }

  // 헤더 날짜 변환
  const headerStartDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);

    return `${date.getFullYear()}년 ${date.getMonth() + 1}월 ${date.getDate()}일`;
  };


  const detailHeaderTitle = {
    startDate: headerStartDate(detailData.schedule.saildate), //출발일
    sailRegion: detailData.schedule.region_name, //여행지역
    sailNights: detailData.schedule.nights, // 기간
    cruiseName: detailData.schedule.ship_name_ko || detailData.schedule.ship_name_en // 선박명
  }

  // console.log('상품 상세데이터',detailData);
  // console.log('상품 선실데이터',detailPriceData);

  return (
    <div className="detail-section">
      <div className="detail-wrapper">
        <DetailHeader
          productId={detailData.schedule.id}
          productCode={detailData.schedule.voyagecode}
          // productName={detailData.schedule.name}
          // productShipName={detailData.schedule.ship_name_ko || detailData.schedule.ship_name_en}
          productTitle={detailHeaderTitle}
          productThumbnail={detailData.schedule.ship_main_image}
          productParlors={detailPriceData}
          productCabinTypes={detailData.cabin_types}
          productEvent={detailData.schedule}
        />
        <DetailBody
          config={detailData}
          parlorPrices={detailPriceData}
          reservationFlag={detailData.schedule.line_reservation_flg}
        />
      </div>
    </div>
  )
}
